import { useContext } from 'react';
import { FileActionsContext } from '../Context';

export const useFileActions = () => {
  const actions = useContext(FileActionsContext);

  return actions;
};

export default useFileActions;